// Mock data for Dolphin Power landing page
// This will be replaced with real backend data later

export const testimonials = [
  {
    id: '1',
    name: 'Sarah Mitchell',
    business: 'The Harbour Café, Brixham',
    rating: 5,
    text: 'Switching to Dolphin Power was the best decision for our café. Their local knowledge and personal approach made everything so simple. We\'ve seen real savings on our energy bills.',
    avatar: 'SM'
  },
  {
    id: '2',
    name: 'Tom Richards',
    business: 'Seabreeze B&B, Paignton',
    rating: 5,
    text: 'As a small B&B, we needed someone who understood our unique needs. Carrie and the team have been fantastic - always available and genuinely care about helping us.',
    avatar: 'TR'
  },
  {
    id: '3',
    name: 'Emma Davies',
    business: 'Coastal Gifts, Torquay',
    rating: 5,
    text: 'Finally, an energy provider that speaks our language! No confusing jargon, just honest advice and real support. Highly recommend to any South Devon business.',
    avatar: 'ED'
  }
];

export const services = [
  {
    id: '1',
    icon: 'TrendingDown',
    title: 'Lower Your Bills',
    description: 'We analyse your energy usage to find cost-saving opportunities tailored to your business needs.'
  },
  {
    id: '2',
    icon: 'Users',
    title: 'Face-to-Face Support',
    description: 'Personal, local service. Meet us in person and get the support you deserve from people who care.'
  },
  {
    id: '3',
    icon: 'Gauge',
    title: 'Meter Reads & Management',
    description: 'We handle all the technical details so you can focus on running your business with confidence.'
  },
  {
    id: '4',
    icon: 'Shield',
    title: 'Clear, Honest Pricing',
    description: 'No hidden fees or confusing terms. Just transparent pricing and straightforward guidance.'
  }
];

export const businesses = [
  {
    id: '1',
    icon: 'Bed',
    title: 'B&Bs, Guesthouses & Hotels',
    description: 'Tailored energy solutions for accommodation businesses across South Devon.'
  },
  {
    id: '2',
    icon: 'Coffee',
    title: 'Cafés & Restaurants',
    description: 'Keep your costs down while serving up the best to your customers.'
  },
  {
    id: '3',
    icon: 'Store',
    title: 'Shops & Retail',
    description: 'Smart energy management for local retailers and independent shops.'
  },
  {
    id: '4',
    icon: 'Building2',
    title: 'Local Businesses',
    description: 'Whatever your trade, we provide energy solutions that work for you.'
  }
];

export const stats = [
  {
    id: '1',
    value: '150+',
    label: 'Local Businesses Served'
  },
  {
    id: '2',
    value: '£200k+',
    label: 'Total Savings Generated'
  },
  {
    id: '3',
    value: '100%',
    label: 'South Devon Focused'
  },
  {
    id: '4',
    value: '24/7',
    label: 'Support Available'
  }
];

export const contactInfo = {
  email: 'splash@dolphinpower.co.uk',
  phone: '01803 900127',
  location: 'South Devon, United Kingdom'
};